import { Call } from '@src/services/api';
import { ApiTypes, CRMTemplateView } from 'common';
import { BodyCreateCRMTemplate, BodyEditCRMTemplate } from 'common/dist/types/apiTypes';

// Fetch all CRM templates
export const getCrmTemplates = async () => {
  const res = await Call.get<ApiTypes.ResGetTemplates>('/api/crm/templates');
  return res || [];
};

// Create a new CRM template
export const createCrmTemplate = async (data: BodyCreateCRMTemplate): Promise<ApiTypes.ResCreateTemplate> => {
  const res = await Call.post<CRMTemplateView, BodyCreateCRMTemplate>('/api/crm/templates', data);
  return res;
};

// Update an existing CRM template
export const updateCrmTemplate = async (data: BodyEditCRMTemplate): Promise<ApiTypes.ResUpdateTemplate> => {
  const res = await Call.put<CRMTemplateView, BodyEditCRMTemplate>(`/api/crm/templates/${data._id}`, data);
  return res;
};

// Delete a CRM template
export const deleteCrmTemplate = async (id: string): Promise<ApiTypes.ResDeleteTemplate> => {
  return Call.delete(`/api/crm/templates/${id}`);
};
